import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css'

import 'quill/dist/quill.snow.css'

import '@/styles/auxiliumno.css'

import {createPinia} from "pinia";

const pinia = createPinia()

createApp(App).use(pinia).use(router).mount('#app')
